import endpoints from '../../API/endpoints'
import callAPI from '../../API/callSecureAPI'
import { useAuth0 } from '../../contexts/auth0-context'
import { useQuery } from 'react-query'

export interface KES {
    _id: string
    statement: string
    figures: string[]
    status: 'pending' | 'approved' | 'rejected'
    parentDraft: string
    strategyId: string
    organizationId: string
}

export const useGetDraftKES = (
    draftId: string,
    enabled: boolean,
    refetchInterval?: number | false | ((data: KES[] | undefined) => number | false)
) => {
    const { getTokenSilently } = useAuth0()

    const fetchKES = async (): Promise<KES[]> => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        const res = await callAPI(endpoints.getKESByDraftId.url + draftId, endpoints.getKESByDraftId.method, token)
        return res?.data || []
    }

    return useQuery<KES[]>(['draftKES', draftId], fetchKES, {
        enabled: enabled && !!draftId,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        refetchInterval,
    })
}
